<template>
  <settings-modal class="swift-message-order-cancel-modal">
    <template slot="heading">Cancel swift message order {{ swiftMessageOrderId }}?</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_SWIFT_MESSAGE_ORDER_UPDATE } from '@/events/swiftMessageOrders'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import SwiftMessageOrderApi from '@/services/Api/SwiftMessageOrderApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'SwiftMessageOrderCancelModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        swiftMessageOrderCancelApiRequest: new ApiRequest(SwiftMessageOrderApi.cancel)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      swiftMessageOrderId () {
        return this.modal.data.swiftMessageOrderId
      },
      loading () {
        return this.swiftMessageOrderCancelApiRequest.loading
      },
      error () {
        return this.swiftMessageOrderCancelApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.cancelSwiftMessageOrder(this.swiftMessageOrderId)
          .then(() => {
            this.$eventHub.$emit(EVENT_SWIFT_MESSAGE_ORDER_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Swift message order has been successfully canceled.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      cancelSwiftMessageOrder (swiftMessageOrderId) {
        return this.swiftMessageOrderCancelApiRequest.execute(swiftMessageOrderId)
      }
    }
  }
</script>

<style lang="scss">
  .swift-message-order-cancel-modal {
    &.settings-modal {
      .container {
        padding-bottom: 28px;
      }
    }
  }
</style>
